import ProfileListContainer from '../../containers/profile/ProfileListContainer'

const ProfileListPage = () => {
  return <ProfileListContainer />
}

export default ProfileListPage
